import PostProcessRT from '../postProcessRT'
import Rendable from '@/glxp/abstract/rendable'
import { vec2 } from 'gl-matrix'
import DebugController from '@/glxp/debug/debugController'

const CONFIG = {
  radius_mutiplicator: { value: 1, range: [0, 5] },
  size_influence: { value: 2, range: [0, 10] },
  speed_influence: { value: 2, range: [0, 10] },
  stiffness: { value: 0.1, range: [0, 1] }
}

const VERTICES = [-1, 1, 0, -1, -1, 0, 1, -1, 0, 1, 1, 0]
const INDICES = [0, 1, 2, 0, 2, 3]
const UVS = [
  0, 1,
  0, 0,
  1, 0,
  1, 1
]

class PostPassMarbling extends Rendable {
  constructor(scene, shader, advanced = true, enableFloat = true, direction = [1, 0]) {
    super(scene)
    this.hasNormal = false
    this.advanced = advanced
    this.enableFloat = enableFloat
    this.everDraw = false
    this.firstDraw = false
    this.direction = direction

    // this.onlyVertices = false
    this.initProgram(shader.vert, shader.passes[0]);
    this.initBuffer({
      vertices: VERTICES,
      uvs: UVS,
      indices: INDICES
    })
    this.initVao()
    this.createUniforms()

    this.cursorDir = vec2.create()
    this.customShift = 0
    this.customShiftWidth = 0
    this.customShiftVertical = false

    if (enableFloat) {
      this.rts = [
        new PostProcessRT(this.scene, 1, 'float'),
        new PostProcessRT(this.scene, 1, 'float')
      ]
    } else {
      this.rts = [
        new PostProcessRT(this.scene, .05),
        new PostProcessRT(this.scene, .05),
      ]
      this.rts[0].everDraw = false
      this.rts[1].everDraw = false
    }
    // this.rts = [
    //   new PostProcessRT(this.scene, 1, 'float'),
    //   new PostProcessRT(this.scene, 1, 'float')
    // ]
    this.activeRt = 0

    DebugController.addConfig(CONFIG, 'marbling')

    this.useCustomParams = false
    this.customParams = null

    

  }

  createUniforms () {
    this.createUniform('uTexture', 'texture')
    this.createUniform('uRez', 'float2')
    this.createUniform('uMouse', 'float2')
    this.createUniform('uDir', 'float2')
    this.createUniform('uDirection', 'float2')
    this.createUniform('uRadius')
    this.createUniform('uStrength')
    this.createUniform('uSpeed')
    this.createUniform('uCustomShift')
    this.createUniform('uCustomWidth')
    this.createUniform('uCustomShiftRot')
    this.createUniform('uCustomShiftVertical')
    this.createUniform('uFirstPass')
  }

  applyState () {
    let gl = this.gl
    this.scene.applyDefaultState()
    gl.disable(gl.DEPTH_TEST)
    // gl.disable(gl.BLEND)
  }

  preRender () {
    let id = this.activeRt == 0 ? 1 : 0
    this.rts[id].preRender()
  }

  postRender () {
    let id = this.activeRt == 0 ? 1 : 0
    this.rts[id].postRender()
    this.activeRt = this.activeRt == 0 ? 1 : 0
  }

  bind () {
    let id = this.activeRt == 0 ? 1 : 0
    this.rts[id].bind()
  }

  render () {
    let gl = this.gl

    this.preRender()
    if (this.firstDraw == false) {
      this.firstDraw = true;
      setTimeout(() => {
        this.everDraw = true
      }, 50);
    }

    let _config = CONFIG
    if (this.useCustomParams) {
      _config = this.customParams
    }

    gl.useProgram(this.program)
    gl.bindVertexArray(this.vao)
    this.applyState()

    gl.activeTexture(gl.TEXTURE0)
    this.rts[this.activeRt].bind()
    this.bindUniform('uTexture', 0)

    this.bindUniform('uRez', [this.scene.width, this.scene.height])
    this.bindUniform('uMouse', this.scene.cursor)

    vec2.sub(this.cursorDir, this.scene.cursor, this.scene.lastCursor)
    this.bindUniform('uDir', this.cursorDir)

    // console.log(this.scene.shakeFactor )
    this.bindUniform('uRadius', (0.5 - Math.min(this.scene.shakeFactor * _config.size_influence.value, 0.5)) * _config.radius_mutiplicator.value)
    // let strength = (Math.easing.easeOutCubic(this.scene.shakeFactor) * 2) + .08
    let strength = (Math.easing.easeOutCubic(this.scene.shakeFactor) * _config.speed_influence.value)
    this.bindUniform('uStrength', strength)

    let speed = _config.stiffness.value
    let s = speed - Math.easing.easeOutQuint(this.scene.step) * speed
    if (this.advanced == false) {
      s = speed
    }
    let fade = (1 - s) + (this.scene.shakeFactor * s)
    // this.bindUniform("uSpeed", 0.01);
    this.bindUniform("uSpeed", fade);
    this.bindUniform("uDirection", this.direction);
    this.bindUniform('uCustomShift', this.customShift)
    this.bindUniform('uCustomWidth', this.customShiftWidth)
    this.bindUniform("uFirstPass", this.everDraw ? 0 : 1);
    this.bindUniform('uCustomShiftVertical', this.customShiftVertical == false ? 0 : 1)
    // console.log(strength)

    gl.drawElements(gl.TRIANGLES, INDICES.length, gl.UNSIGNED_SHORT, 0)
    gl.bindVertexArray(null)

    this.postRender()

    this.rts[this.activeRt].everDraw = true;
    // if (this.rts[0].everDraw && this.rts[1].everDraw) {
    //   this.everDraw = true
    // }
  }
}

export default PostPassMarbling
